
const PostMessages = {

  currentConfiguration: null,
  currentSetConfiguration: null,
  currentPlayer: null,
  setted: false,

  onConfiguration: (configuration, setConfiguration = null) => {
    PostMessages.currentConfiguration = configuration;
    PostMessages.currentSetConfiguration = setConfiguration;
  },

  onPlayer: player => {
    PostMessages.currentPlayer = player;
  },

  handleMessage: message => {   // REVIEW TODO encolar / gestionar / enviar respuesta informando, de eventos que no se han procesado por estado temporal
    try {                           // ejemplo: aun no se ha cargado la configuracion o el player,    NOTE de momento solo se ignoran
      const handlerState = {
        updatedConfiguration: null,
        unprocessedMessage: true,
      };

      if( PostMessages.currentConfiguration?.PlayerComponent?.specificPostMessagesHandler?.handleMessage) {
        const { updatedConfiguration, unprocessedMessage } = PostMessages.currentConfiguration.PlayerComponent.specificPostMessagesHandler.handleMessage( message, PostMessages.currentConfiguration, PostMessages.currentPlayer);
        handlerState.updatedConfiguration = updatedConfiguration;
        handlerState.unprocessedMessage = unprocessedMessage;
      }
  
      switch( message.data.operation) {
        default:
          if( handlerState.unprocessedMessage) console.warn( 'controllers::PostMessages::handleMessage() - Unrecognize operation: ', message.data.operation);
      }
  
      if( handlerState.updatedConfiguration && PostMessages.currentSetConfiguration) {
        PostMessages.currentSetConfiguration( handlerState.updatedConfiguration);
      }

    } catch( error) {
      console.error( 'controllers::PostMessages::handleMessage() - error: ', error);
    }
  },

  listen: _ => {
    window.addEventListener( 'message', PostMessages.handleMessage, false);
    PostMessages.setted = true;
  },

  stop: _ => {
    if( PostMessages.setted) {
      window.removeEventListener( 'message', PostMessages.handleMessage);
      PostMessages.setted = false;
    }
  },

};

export default PostMessages;